import { FIELD_STATUS, FORM_STATUS } from '../status';

import {
    REINITIALIZE,
    DECLINED_PROPOSAL_SET_VALUE,
    DECLINED_PROPOSAL_SET_VALID,
    DEFECT_VISION_SET_VALUE,
    DEFECT_VISION_SET_VALID,
    CONVICTED_SET_VALUE,
    CONVICTED_SET_VALID,
    INCREASED_PREMIUMS_SET_VALUE,
    INCREASED_PREMIUMS_SET_VALID,
    POLICY_REJECTED_SET_VALUE,
    POLICY_REJECTED_SET_VALID,
    STICKER_COLLECTION_SET_VALUE,
    STICKER_COLLECTION_SET_VALID,
    MODE_OF_PAYMENT_SET_VALUE,
    MODE_OF_PAYMENT_SET_VALID,
    SOURCE_OF_FUNDS_SET_VALUE,
    SOURCE_OF_FUNDS_SET_VALID,
    FORM_VALID_MOTOR_INSURANCE_DECLARATIONS_FORM,
    FORM_INVALID_MOTOR_INSURANCE_DECLARATIONS_FORM,
    OTHER_SOURCE_OF_FUNDS_SET_VALUE,
    OTHER_SOURCE_OF_FUNDS_SET_VALID,
    SOLE_OWNERSHIP_SET_VALUE,
    SOLE_OWNERSHIP_SET_VALID,
    PURCHASE_AGREEMENT_SET_VALUE,
    PURCHASE_AGREEMENT_SET_VALID,
    PARKING_SET_VALUE,
    PARKING_SET_VALID,
    DOMESTIC_PURPOSES_SET_VALID,
    DOMESTIC_PURPOSES_SET_VALUE,
    BUSINESS_PURPOSES_SET_VALUE,
    BUSINESS_PURPOSES_SET_VALID,
    EMPLOYEE_USE_SET_VALUE,
    EMPLOYEE_USE_SET_VALID,
    TRADE_GOODS_USE_SET_VALUE,
    TRADE_GOODS_USE_SET_VALID,
    OTHER_PURPOSE_USE_SET_VALUE,
    OTHER_PURPOSE_USE_SET_VALID,
    OTHER_PURPOSE_DESC_SET_VALUE,
    OTHER_PURPOSE_DESC_SET_VALID,
    COMPANY_NAME_SET_VALUE,
    COMPANY_NAME_SET_VALID,
    SHOW_CALL_ME_BACK_MODAL_SET_VALUE,
    DECLARATIONS_SUBMITTED_SET_VALUE,
} from '../../actions/ugMotorInsurance/declarations';

export const initDeclaration = {
    formStatus: FORM_STATUS.VALID,
    dropOffDetails: null,
    declarationReferenceData: null,
    apiCallStatus: null,
    showCallMeBackModal: false,
    declarationsSubmitted: false,
    form: {
        declineProposal: { value: null, status: null, error: null },
        increasedPremiums: { value: null, status: null, error: null },
        policyRejected: { value: null, status: null, error: null },
        defectVision: { value: null, status: null, error: null },
        convicted: { value: null, status: null, error: null },
        stickerCollection: { value: 'Nakawa Business Park - Head Office', status: null, error: null },
        modeOfPayment: { value: 'EFT/ RTGS', status: null, error: null },
        sourceOfFunds: { value: 'Salaried Employee', status: null, error: null },
        otherSourceOfFunds: { value: null, status: null, error: null },
        soleOwnership: { value: null, status: null, error: null },
        purchaseAgreement: { value: null, status: null, error: null },
        parking: { value: null, status: null, error: null },
        domesticPurposes: { value: null, status: null, error: null },
        businessPurposes: { value: null, status: null, error: null },
        employeeUse: { value: null, status: null, error: null },
        tradeGoodsUse: { value: null, status: null, error: null },
        otherPurposeUse: { value: null, status: null, error: null },
        otherPurposeDesc: { value: null, status: null, error: null },
        companyName: { value: null, status: null, error: null },
    },
};

export default (state = initDeclaration, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_MOTOR_INSURANCE_DECLARATIONS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_MOTOR_INSURANCE_DECLARATIONS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case DECLARATIONS_SUBMITTED_SET_VALUE:
            return { ...state, declarationsSubmitted: action.value };

        case DECLINED_PROPOSAL_SET_VALUE:
            return updateFormField('declineProposal', (field) => ({ ...field, value: action.value }));

        case DECLINED_PROPOSAL_SET_VALID:
            return updateFormField('declineProposal', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case INCREASED_PREMIUMS_SET_VALUE:
            return updateFormField('increasedPremiums', (field) => ({ ...field, value: action.value }));

        case INCREASED_PREMIUMS_SET_VALID:
            return updateFormField('increasedPremiums', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case POLICY_REJECTED_SET_VALUE:
            return updateFormField('policyRejected', (field) => ({ ...field, value: action.value }));

        case POLICY_REJECTED_SET_VALID:
            return updateFormField('policyRejected', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DEFECT_VISION_SET_VALUE:
            return updateFormField('defectVision', (field) => ({ ...field, value: action.value }));

        case DEFECT_VISION_SET_VALID:
            return updateFormField('defectVision', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CONVICTED_SET_VALUE:
            return updateFormField('convicted', (field) => ({ ...field, value: action.value }));

        case CONVICTED_SET_VALID:
            return updateFormField('convicted', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case STICKER_COLLECTION_SET_VALUE:
            return updateFormField('stickerCollection', (field) => ({ ...field, value: action.value }));

        case STICKER_COLLECTION_SET_VALID:
            return updateFormField('stickerCollection', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case MODE_OF_PAYMENT_SET_VALUE:
            return updateFormField('modeOfPayment', (field) => ({ ...field, value: action.value }));

        case MODE_OF_PAYMENT_SET_VALID:
            return updateFormField('modeOfPayment', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SOURCE_OF_FUNDS_SET_VALUE:
            return updateFormField('sourceOfFunds', (field) => ({ ...field, value: action.value }));

        case SOURCE_OF_FUNDS_SET_VALID:
            return updateFormField('sourceOfFunds', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case OTHER_SOURCE_OF_FUNDS_SET_VALUE:
            return updateFormField('otherSourceOfFunds', (field) => ({ ...field, value: action.value }));

        case OTHER_SOURCE_OF_FUNDS_SET_VALID:
            return updateFormField('otherSourceOfFunds', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SOLE_OWNERSHIP_SET_VALUE:
            return updateFormField('soleOwnership', (field) => ({ ...field, value: action.value }));

        case SOLE_OWNERSHIP_SET_VALID:
            return updateFormField('soleOwnership', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PURCHASE_AGREEMENT_SET_VALUE:
            return updateFormField('purchaseAgreement', (field) => ({ ...field, value: action.value }));

        case PURCHASE_AGREEMENT_SET_VALID:
            return updateFormField('purchaseAgreement', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PARKING_SET_VALUE:
            return updateFormField('parking', (field) => ({ ...field, value: action.value }));

        case PARKING_SET_VALID:
            return updateFormField('parking', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DOMESTIC_PURPOSES_SET_VALUE:
            return updateFormField('domesticPurposes', (field) => ({ ...field, value: action.value }));

        case DOMESTIC_PURPOSES_SET_VALID:
            return updateFormField('domesticPurposes', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case BUSINESS_PURPOSES_SET_VALUE:
            return updateFormField('businessPurposes', (field) => ({ ...field, value: action.value }));

        case BUSINESS_PURPOSES_SET_VALID:
            return updateFormField('businessPurposes', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMPLOYEE_USE_SET_VALUE:
            return updateFormField('employeeUse', (field) => ({ ...field, value: action.value }));

        case EMPLOYEE_USE_SET_VALID:
            return updateFormField('employeeUse', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case TRADE_GOODS_USE_SET_VALUE:
            return updateFormField('tradeGoodsUse', (field) => ({ ...field, value: action.value }));

        case TRADE_GOODS_USE_SET_VALID:
            return updateFormField('tradeGoodsUse', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case OTHER_PURPOSE_USE_SET_VALUE:
            return updateFormField('otherPurposeUse', (field) => ({ ...field, value: action.value }));

        case OTHER_PURPOSE_USE_SET_VALID:
            return updateFormField('otherPurposeUse', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case OTHER_PURPOSE_DESC_SET_VALUE:
            return updateFormField('otherPurposeDesc', (field) => ({ ...field, value: action.value }));

        case OTHER_PURPOSE_DESC_SET_VALID:
            return updateFormField('otherPurposeDesc', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case COMPANY_NAME_SET_VALUE:
            return updateFormField('companyName', (field) => ({ ...field, value: action.value }));

        case COMPANY_NAME_SET_VALID:
            return updateFormField('companyName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SHOW_CALL_ME_BACK_MODAL_SET_VALUE:
            return { ...state, showCallMeBackModal: action.value };

        // Reset the state
        case REINITIALIZE:
            return initDeclaration;
        default:
            return state;
    }
};
